/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * home_location object
 * @export
 * @interface GetCharactersCharacterIdClonesHomeLocation
 */
export interface GetCharactersCharacterIdClonesHomeLocation {
    /**
     * location_id integer
     * @type {number}
     * @memberof GetCharactersCharacterIdClonesHomeLocation
     */
    locationId?: number;
    /**
     * location_type string
     * @type {string}
     * @memberof GetCharactersCharacterIdClonesHomeLocation
     */
    locationType?: GetCharactersCharacterIdClonesHomeLocationLocationTypeEnum;
}


/**
 * @export
 */
export const GetCharactersCharacterIdClonesHomeLocationLocationTypeEnum = {
    Station: 'station',
    Structure: 'structure'
} as const;
export type GetCharactersCharacterIdClonesHomeLocationLocationTypeEnum = typeof GetCharactersCharacterIdClonesHomeLocationLocationTypeEnum[keyof typeof GetCharactersCharacterIdClonesHomeLocationLocationTypeEnum];


/**
 * Check if a given object implements the GetCharactersCharacterIdClonesHomeLocation interface.
 */
export function instanceOfGetCharactersCharacterIdClonesHomeLocation(value: object): value is GetCharactersCharacterIdClonesHomeLocation {
    return true;
}

export function GetCharactersCharacterIdClonesHomeLocationFromJSON(json: any): GetCharactersCharacterIdClonesHomeLocation {
    return GetCharactersCharacterIdClonesHomeLocationFromJSONTyped(json, false);
}

export function GetCharactersCharacterIdClonesHomeLocationFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCharactersCharacterIdClonesHomeLocation {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': json['location_id'] == null ? undefined : json['location_id'],
        'locationType': json['location_type'] == null ? undefined : json['location_type'],
    };
}

export function GetCharactersCharacterIdClonesHomeLocationToJSON(json: any): GetCharactersCharacterIdClonesHomeLocation {
    return GetCharactersCharacterIdClonesHomeLocationToJSONTyped(json, false);
}

export function GetCharactersCharacterIdClonesHomeLocationToJSONTyped(value?: GetCharactersCharacterIdClonesHomeLocation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'location_id': value['locationId'],
        'location_type': value['locationType'],
    };
}

